import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import DocumentMeta from 'react-document-meta';
import FeaturedOrgCard from './FeaturedOrgCard';
import  Slider  from 'react-slick';


export default class FeaturedOrgs extends React.Component {
  constructor(props) {
    super(props);
  };


  render() {
    let featuredOrgs = '';
    featuredOrgs = this.props.featuredOrgs;
    let orgs = '';

    if (!this.props.featuredOrgs.isLoaded) {
      return <span />
    }

    let settings = {
      autoplay: false,
      infinite: true,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      rtl: true
    };

    let browser = this.props.browser;

    if(browser.greaterThan.phablet) {
      settings.slidesToShow = 2;
      settings.slidesToScroll = 1;
    }

    if(browser.greaterThan.tablet) {
      settings.slidesToShow = 3;
      settings.slidesToScroll = 1;
    }

    if(browser.greaterThan.tabletLandscape) {
      settings.slidesToShow = 4;
      settings.slidesToScroll = 4;
    }


    let featuredOrgList = '';
    let regionLabel = '';
    let regionLabelArray = '';
    featuredOrgList = featuredOrgs.map((region, index) => {
      if (region.orgs) {

        regionLabelArray = region.region.split(',')
        regionLabel = regionLabelArray[0];

        orgs = region.orgs.map((org, index) => {

          return <div key={`slide-${index}`}>
            <FeaturedOrgCard
              category = {org.category}
              db_id = {org.db_id}
              name = {org.name}
              thumbnail_text = {org.thumbnail_text}
              image_icon = {org.image_icon}
              image_home_feature = {org.image_home_feature}
              category_root = {org.category_root}
              slug = {org.slug}
            />

          </div>;
        });
      }

      return <div  className="homeFeaturedOrgs-regionWrapper">
        <div className="homeFeaturedOrgs-region section-description">{regionLabel}</div>
        <Slider { ...settings }>{orgs}</Slider>
      </div>;

    });




    return (
      <main>
        <div className="homeFeaturedOrgs-outerWrapper">
          <div className="homeFeaturedOrgs-innerWrapper">
            <h4 className="section-title">Search across 23 cities in 13 countries</h4>
            <div className="section-description">Connect with nearby resources in your city that make your life a little better</div>

            {featuredOrgList}
          </div>
        </div>
      </main>
    )
  }

};



// WEBPACK FOOTER //
// ./src/components/featuredOrgsHomePage/FeaturedOrgs.jsx